import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isTokenExpired } from "../services/auth";

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (isTokenExpired()) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  if (isTokenExpired()) {
    return null;
  }

  return children;
}
